import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PolicyStreamFormCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
  },
}));
